/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Different_AnswerInputs */

const en_faq_different_answer = /** @type {(inputs: Faq_Different_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You’re working with an engineering partner who learns the process, connects your applications and builds the system around your team. We also plan how it will be tested, handed over and maintained.`)
};

const lv_faq_different_answer = /** @type {(inputs: Faq_Different_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūs sadarbojaties ar programmatūras izstrādes partneri, kas iepazīst procesu, savieno Jūsu lietotnes un veido sistēmu atbilstoši Jūsu komandas darbam. Plānojam arī tās pārbaudi, nodošanu un uzturēšanu.`)
};

/**
* | output |
* | --- |
* | "You’re working with an engineering partner who learns the process, connects your applications and builds the system around your team. We also plan how it wil..." |
*
* @param {Faq_Different_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_different_answer = /** @type {((inputs?: Faq_Different_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Different_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_different_answer(inputs)
	return en_faq_different_answer(inputs)
});